import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Primary submission, persists to backend (MongoDB)
export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};

// URL-encode a flat object for Netlify Forms
const encodeForm = (data) =>
  Object.keys(data)
    .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");

// Netlify Forms submission, captured by Netlify when deployed there.
// Posts to site root with the encoded body Netlify expects.
export const submitNetlify = async (payload) => {
  return fetch("/", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: encodeForm({ "form-name": "contact", ...payload }),
  });
};
